import React, { useState, useEffect, useRef } from "react";
import "./FloatingMenu.css";
import { DashboardPlusicon } from "../../Icons/DashboardPlusicon";
import { ApplicantDeleteIcon } from "../../Icons/ApplicantDeleteIcon";
import { AddToProject } from "../../Icons/AddToProject";
import { SendSMS } from "../../Icons/SendSMS";
import { ApplicantEditIcon } from "../../Icons/ApplicantEditIcon";
import { Clone } from "../../Icons/Clone";
import { Tooltip } from "@mui/material";
import { ApplicantCallIcon } from "../../Icons/ApplicantCallIcon";
import { ApplicantMailIcon } from "../../Icons/ApplicantMailIcon";
import { ApplicantWhatsAppIcon } from "../../Icons/ApplicantWhatsAppIcon";

const ICON_MAP = {
  ApplicantDeleteIcon,
  AddToProject,
  SendSMS,
  ApplicantEditIcon,
  ApplicantMailIcon,
  ApplicantCallIcon,
  ApplicantWhatsAppIcon,
  Clone,
};

const FloatingMenu = ({
  config,
  floatingMenuOptions,
  onReceiveActionHandler,
  storedTheme,
}) => {
  const [openFloatingMenu, setOpenFloatingMenu] = useState(false);

  const menuOptions =
    config?.menuOptions || floatingMenuOptions?.menuOptions || [];
  const mainActions =
    config?.inlineOptions || floatingMenuOptions?.inline || [];

  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenFloatingMenu(false);
      }
    };

    if (openFloatingMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openFloatingMenu]);

  return (
    <>
      {/* Main Action Buttons */}
      {mainActions?.length > 0 && (
        <div className="main-actions" style={{ marginRight: menuOptions.length > 0 ? "60px" : "0px" }}>
          {mainActions.map((action, index) => {
            const IconComponent = ICON_MAP[action.icon];
            return (
              <Tooltip title={action.label} placement="top" key={index}>
                <span
                  key={index}
                  onClick={() => onReceiveActionHandler(action.action, true)}
                >
                  {IconComponent && <IconComponent />}
                </span>
              </Tooltip>
            );
          })}
        </div>
      )}
      {menuOptions?.length > 0 && (
        <section
          className="floatingMenu"
          style={{ marginTop: "-5px" }}
          ref={menuRef}
        >
          {/* FAB Button */}
          <div
            className={`fab ${openFloatingMenu ? "active" : ""}`}
            onClick={() => setOpenFloatingMenu(!openFloatingMenu)}
          >
            <DashboardPlusicon width={35} height={36} />
          </div>

          {/* SVG Background */}
          {openFloatingMenu && (
            <svg
              id="fab-expend-bg"
              data-name="Group 42457"
              width="358.132"
              height="139.141"
              viewBox="0 0 358.132 139.141"
            >
              <g clipPath="url(#clip-path)">
                <path
                  d="M280.816,1.6c-15.768-7.017-28.049,9.8-71.184,35.069-15.015,8.795-36.5,37.578-42.072,53.847-5.588,16.3-19.819,32.653-54.428,32.653H0v15.97H358.132V81.926c0-3.047-1.047-7.71-2.79-12.97-7.559-22.8-52.578-57.587-74.526-67.354"
                  fill={storedTheme?.secondaryColor}
                />
              </g>
            </svg>
          )}

          {/* Menu Options */}
          {openFloatingMenu && (
            <div className="menu">
              {menuOptions?.map((option, index) => (
                <button
                  key={index}
                  onClick={() => {
                    onReceiveActionHandler(option.action, true);
                    setOpenFloatingMenu(false);
                  }}
                >
                  {option.label}
                </button>
              ))}
            </div>
          )}
        </section>
      )}
    </>
  );
};

export default FloatingMenu;
